module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/import-0619e3355425f95efb54a8da8078d63d.svg";